$(document).ready(function () {
    // AOS.init();
    $(".top-slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: "linear",
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

    $(document).on("click", "#close-popup", function () {
        sessionStorage.setItem("langcheck", "1");
        $(".popup-wrapper").removeClass("active");
    });

    $(".size-guide-carousel").slick({
        infinite: false,
        arrows: true,
        slidesToShow: 1,
        prevArrow: $(".size-guide-left"),
        nextArrow: $(".size-guide-right"),
    });

    $("#announcement-bar-slick").slick({
        infinite: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 20000,
        arrows: false,
        cssEase: "linear",
        slidesToShow: 1
    });

    $("#announcement-bar-slick").css("display", "block");

    $(".gallery-slider").slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: true,
        prevArrow: $(".left-arrow1"),
        nextArrow: $(".right-arrow1"),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $.ajax({
        url: "../../../browsing_context_suggestions.json",
    }).done(function (data) {
        console.log(data);
        let popup = sessionStorage.getItem("langcheck");

        if (
            data.detected_values.country.handle == "CA" &&
            (window.location.hostname == "racnroll.com" || window.location.hostname == "rac-n-roll-dance-bags-and-accessories.myshopify.com")
        ) {
            if (!popup) {
                $(".popup-wrapper").addClass("active canada-us");
            }
        } else if (
            data.detected_values.country.handle == "US" &&
            (window.location.hostname == "racnroll.ca" || window.location.hostname == "rac-n-roll-dance-bags-and-accessories-ca.myshopify.com")
        ) {
            if (!popup) {
                $(".popup-wrapper").addClass("active us-canada");
            }
        } else if (
            data.detected_values.country.handle == "AU" &&
            (window.location.hostname == "racnroll.com" || window.location.hostname == "rac-n-roll-dance-bags-and-accessories.myshopify.com")
        ) {
            if (!popup) {
                $(".popup-wrapper").addClass("active aus-us");
            }
        }
    });
});
